module.exports = __webpack_public_path__ + "static/img/btn-UpLoading.1d60d8db.png";